import { darken } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import { ANNOUNCEMENT_BAR_HEIGHT } from '../../utils/constants';

const DISMISS_BUTTON_RESERVE_PX = 48;

export const useAnnouncementBarStyles = makeStyles()((theme) => ({
  root: {
    height: ANNOUNCEMENT_BAR_HEIGHT,
    minHeight: ANNOUNCEMENT_BAR_HEIGHT,
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    gap: theme.spacing(1),
    paddingInlineStart: theme.spacing(2),
    paddingInlineEnd: DISMISS_BUTTON_RESERVE_PX,
    backgroundColor: theme.palette.accent.dark,
    color: theme.palette.accent.contrastText,
    boxSizing: 'border-box',
    '& *': {
      boxSizing: 'border-box',
    },
  },
  message: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    minWidth: 0,
    lineHeight: 1,
    '& .MuiTypography-root': {
      lineHeight: 1,
    },
  },
  symbol: {
    height: 17,
    width: 'auto',
    flexShrink: 0,
  },
  learnMore: {
    textDecoration: 'underline',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    flexShrink: 0,
  },
  dismiss: {
    position: 'absolute',
    right: theme.spacing(1),
    '&&': {
      color: theme.palette.accent.contrastText,
    },
    '&&:hover': {
      color: theme.palette.accent.contrastText,
      backgroundColor: darken(theme.palette.accent.dark, 0.95),
    },
  },
}));
